import { configureStore, combineReducers, ReducersMapObject } from '@reduxjs/toolkit';

import { api } from '../../api';
import { searchReducer, promptsReducer, Slices, feedReducer } from '../../slices';
import { StateSchema } from '../StoreProvider.types';

const rootReducers: ReducersMapObject<StateSchema> = {
    [api.reducerPath]: api.reducer,
    [Slices.Feed]: feedReducer,
    [Slices.Search]: searchReducer,
    [Slices.Prompts]: promptsReducer,
};

const reducer = combineReducers(rootReducers);

export function createReduxStore(initialState: Partial<StateSchema>) {
    const store = configureStore({
        reducer,
        devTools: process.env.NODE_ENV === 'development',
        preloadedState: initialState,
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware),
    });

    return store;
}
